<template>
    <small class="red">{{data}}</small>
</template>

<script>
    export default {
        name: "MessageContainer",
        props: ["data"],
    }
</script>

<style scoped>

</style>
